<template>
  <v-row class="my-5" justify="center">
    <v-col cols="12" sm="6" md="6" lg="4" xl="4" align="center">
      <v-alert
        v-model="errorMsgAlert"
        close-text="Close Alert"
        class="alert-text mb-5"
        color="error"
        dark
        dismissible
        ref="snackbarError"
      >
        {{ $t(errorMsg) }}
      </v-alert>

      <v-snackbar
        v-model="snackbar"
        class="mt-15"
        color="success"
        :timeout="timeout"
        top
      >
        <div class="text-center py-1" style="font-size: 16px">
          {{ $t(snackbarText) }}
        </div>

        <template v-slot:action="{ attrs }">
          <v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <div v-show="!showPasswordReset">
        <v-form ref="loginForm">
          <!-- <div placeholder="{{ 'Run Site ID' | translate }}"></div> -->
          <v-text-field
            :label="$t(['Run Site ID'])"
            name="Run Site ID"
            v-model="runSiteId"
            :placeholder="$t(['Run Site ID'])"
            prepend-inner-icon="mdi-map-marker"
            :rules="rules.runSiteId"
            persistent-placeholder
            outlined
          ></v-text-field>

          <!-- <div placeholder="{{ 'Run Site Pin' | translate }}"></div> -->
          <v-text-field
            :label="$t(['Run Site Pin'])"
            name="Run Site Pin"
            type="password"
            v-model="runSitePin"
            :placeholder="$t(['Run Site Pin'])"
            prepend-inner-icon="mdi-lock"
            :rules="rules.runSitePin"
            persistent-placeholder
            outlined
          ></v-text-field>
        </v-form>

        <v-btn
          class="btn-text"
          color="primary"
          x-large
          block
          translate
          :loading="loginBtnLoading"
          @click="login()"
        >
          {{ $t(["Login"]) }}
        </v-btn>

        <v-btn
          class="btn-text mt-5"
          x-large
          block
          translate
          @click="showPasswordReset = true"
        >
          {{ $t(["Forgot password"]) }}
        </v-btn>
      </div>

      <div v-show="showPasswordReset">
        <h2 class="title-underline" translate>{{ $t(["Reset Password"]) }}</h2>

        <v-form class="mt-5">
          <v-text-field
            :label="$t(['Run Site ID'])"
            name="Run Site ID"
            v-model="resetRunSiteId"
            prepend-inner-icon="mdi-map-marker"
            :placeholder="$t(['Run Site ID'])"
            :rules="rules.runSiteId"
            persistent-placeholder
            outlined
          ></v-text-field>
        </v-form>

        <v-btn
          class="btn-text btn-multiline px-3"
          color="primary"
          :loading="passwordResetLoading"
          x-large
          block
          translate
          style="font-size: 0.95rem"
          @click="passwordReset()"
        >
          <span class="text-wrap">{{ $t(["Send password reset"]) }}</span>
        </v-btn>

        <v-btn
          class="mt-3"
          style="font-size: 12px"
          text
          translate
          @click="showPasswordReset = false"
        >
          {{ $t(["Back to login"]) }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";
import axios from "axios";

import { useAuthenicationStore } from "../store/authenication";

export default {
  name: "Login",
  data: () => ({
    runSiteId: "",
    runSitePin: "",
    resetRunSiteId: "",
    loginBtnLoading: false,
    passwordResetLoading: false,
    showPasswordReset: false,
    snackbar: false,
    snackbarText: "",
    timeout: 3000,
    errorMsgAlert: false,
    errorMsg: "",
    rules: {
      runSiteId: [],
      runSitePin: [],
      resetRunSiteId: [],
    },
  }),

  setup() {
    const authStore = useAuthenicationStore();

    return {
      authStore,
    };
  },
  mounted() {
    if (this.$route.params.errorMsg != undefined) {
      this.errorMsgAlert = true;
      this.errorMsg = this.$route.params.errorMsg;
    }
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.loginForm.resetValidation();
    },
  },
  methods: {
    setFieldValidationRules() {
      this.rules.runSiteId = [
        (v) => !!v || this.$gettext(this.$t(["Required"])),
      ];
      this.rules.runSitePin = [
        (v) => !!v || this.$gettext(this.$t(["Required"])),
      ];
    },
    async passwordReset() {
      this.passwordResetLoading = true;

      try {
        await this.authStore
          .resetPasswordApi({ runSiteId: this.resetRunSiteId })
          .then((response) => {
            if (response.success) {
              this.snackbar = true;
              this.snackbarText = this.$t(["Successfully reset password"]);

              return;
            } else {
              this.snackbar = false;
              this.snackbarText = "";

              throw response.message;
            }
          });
      } catch (error) {
        this.errorMsgAlert = true;
        this.errorMsg = error.message == undefined ? error : error.message;

        this.$nextTick(() => {
          const el = this.$el.querySelector("snackbarError");
          this.$vuetify.goTo(-5, el);

          return;
        });
      }

      this.passwordResetLoading = false;
    },
    async login() {
      await this.setFieldValidationRules();

      if (this.$refs.loginForm.validate()) {
        this.loginBtnLoading = true;

        try {
          await Auth.signIn(this.runSiteId, this.runSitePin).then(
            async (user) => {
              await this.authStore
                .getAccountApi(user.signInUserSession.idToken.jwtToken)
                .then(() => {
                  if (this.authStore.runSiteInfo.province == "Quebec") {
                    this.$i18n.locale = "fr";
                    this.$cookies.set("tff_language", "fr", "1h");
                  } else {
                    if (!this.$cookies.get("tff_language")) {
                      this.$cookies.set(
                        "tff_language",
                        this.$i18n.locale,
                        "1h"
                      );
                    } else {
                      this.$i18n.locale = this.$cookies.get("tff_language");
                    }
                  }

                  // Clear localStorage of global states if previously there
                  localStorage.removeItem("order");
                  localStorage.removeItem("refund");
                  localStorage.removeItem("status");

                  this.$cookies.remove("tff_authenicateRefundLogin");

                  this.$router.replace({ name: "Home" });
                });
            }
          );
        } catch (error) {
          this.errorMsgAlert = true;
          this.errorMsg = error.message == undefined ? error : error.message;

          this.$nextTick(() => {
            const el = this.$el.querySelector("snackbarError");
            this.$vuetify.goTo(-5, el);

            return;
          });
        }

        this.loginBtnLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
